
<script>
export default {
  name: "dgDragScope",
  data() {
    return {}
  },
  mounted() {

  },
  render(h) {
    return h('div', {
      class: ['dg__drag-scope'],
      ref: "dg__drag-scope",
    }, this.$slots.default);
  }
}
</script>
<style scoped lang="less">
</style>